import { ROUTE } from '../routes';
import { Platform } from 'react-native';
import { isMobile } from "./utils";
export const heightMap = {
    [ROUTE.PAN_CONFIRM_NAME]: 410,
    [ROUTE.CO_BORROWER_PAN_CONFIRM_NAME]: 410,
    [ROUTE.CO_BORROWER_SUMMARY_CONFIRM]: 296,
    [ROUTE.ALERT_PAGE]: Platform.OS !== 'web' ? 350 : 333,
    [ROUTE.WITHDRAWAL_SUCCESS]: 570,
    [ROUTE.WITHDRAWAL_OTP]: 352,
    [ROUTE.LOAN_AUTOPAY]: 258,
    [ROUTE.PLEDGE_VERIFY]: 333,
    [ROUTE.OTP_AUTH_CAS]: Platform.OS !== "web" ? 380 : 350,
    [ROUTE.MF_FETCH_PORTFOLIO]: Platform.OS === 'web' ? 560 : 650,
    [ROUTE.UPDATE_PHONE_NUMBER]: 280,
    [ROUTE.MODIFY_PLEDGED_AMOUNT]: Platform.OS === "ios" ? 320 : Platform.OS === 'android' ? 350 : 290,
    [ROUTE.SELECT_SOURCE]: 358,
    [ROUTE.UPDATE_SLIDER_AMOUNT]: 214,
    [ROUTE.VOLT_APP]: 500,
    [ROUTE.JOINT_HOLDER_NOTIFY]: Platform.OS === "web" ? 370 : 400,
    [ROUTE.DIGIO_MODAL]: Platform.OS === "ios" ? 770 : 750,
    [ROUTE.INVITE_CLIENT]: 365,
    [ROUTE.PARTNER_LOGOUT]: 163,
    [ROUTE.EMPANEL_SUCCESS_MODAL]: 523,
    [ROUTE.PARTNER_VIEW_DETAIL_LEAD]: 570,
    [ROUTE.PLATFORM_VIEW_DETAILS]: 570,
    [ROUTE.PLATFORM_LOG_OUT]: 163,
    [ROUTE.CHECK_LIMIT_INFO]: 398,
    [ROUTE.PLATFORM_LOG_OUT]: 163,
    [ROUTE.KYC_DIGIO_RESPONSE]: 0,
    [ROUTE.CONTACT_US_CARD]: Platform.OS === "web" ? 466 : 500,
    [ROUTE.DIGIO_MODAL_CO_BORROWER]: 750,
    [ROUTE.COLLATERAL_INTRO_CARD]: 474,
    [ROUTE.COLLATERAL_DOWNLOAD_INFO]: 1024,
    [ROUTE.COLLATERAL_LANGUAGE_SELECT]: 480,
    [ROUTE.CONTACT_US_CARD_JUPITER]: 360,
    [ROUTE.CONTACT_US_3_CARDS]: Platform.OS === 'ios' ? 520 : 486,
    [ROUTE.CONTACT_US_2_CARDS]: Platform.OS === 'ios' ? 375 : 350,
    [ROUTE.CONTACT_US_1_CARDS]: 250,
    [ROUTE.PAYOUT_DETAILS_SCREEN]: 360,
    [ROUTE.ALERT_PAGE_ONLY_TITLE]: Platform.OS !== 'web' ? 320 : 270,
    [ROUTE.SELECT_SOURCE_3]: isMobile() ? 350 : 330,
    [ROUTE.SELECT_SOURCE_2]: 250,
    [ROUTE.SELECT_SOURCE_1]: 198,
};
